import { EditableTierColumn } from 'customer-management/customer-details/view-contracts/tables/columns/editable-tier-column';
import { Column } from 'react-table';
import { NumberColumn } from 'shared/tables/columns';
import { ViewContractsTiersGridItem } from 'shared/types/customerManagement';

export const viewContractsGrowthIncentiveTiersTableColumns: Column<ViewContractsTiersGridItem>[] = [
  {
    Header: 'Tier',
    align: 'left',
    isPrimary: true,
    accessor: 'tier',
    width: 20,
    minWidth: 20,
    Cell: NumberColumn,
  },
  {
    Header: 'Revenue',
    align: 'center',
    isPrimary: true,
    accessor: 'floor',
    section: 'growthTiers',
    Cell: EditableTierColumn,
  },
  {
    Header: 'Discount',
    align: 'center',
    isPrimary: true,
    accessor: 'rebate',
    section: 'growthTiers',
    percent: true,
    Cell: EditableTierColumn,
  },
];
